import { ApolloLink } from 'apollo-link';
import { RequestTracker, ResponseTracker } from 'services/analytics';

export const trackLink = new ApolloLink((operation, forward) => {
  RequestTracker(operation);
  return forward(operation).map((response) => {
    ResponseTracker(operation, response);
    return response;
  });
});
